var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6V4.5C10.75 2.42893 9.07107 0.75 7 0.75C4.92893 0.75 3.25 2.42893 3.25 4.5V6M7 9.375V10.875M4.6 14.25H9.4C10.6601 14.25 11.2902 14.25 11.7715 14.0048C12.1948 13.789 12.539 13.4448 12.7548 13.0215C13 12.5402 13 11.9101 13 10.65V9.6C13 8.33988 13 7.70982 12.7548 7.22852C12.539 6.80516 12.1948 6.46095 11.7715 6.24524C11.2902 6 10.6601 6 9.4 6H4.6C3.33988 6 2.70982 6 2.22852 6.24524C1.80516 6.46095 1.46095 6.80516 1.24524 7.22852C1 7.70982 1 8.33988 1 9.6V10.65C1 11.9101 1 12.5402 1.24524 13.0215C1.46095 13.4448 1.80516 13.789 2.22852 14.0048C2.70982 14.25 3.33988 14.25 4.6 14.25Z",
    stroke: "#8D94A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.35c0876ab43643dfa44f4e4a35b64331.svg";
export { ForwardRef as ReactComponent };